import { render, staticRenderFns } from "./CalendarNavigation.vue?vue&type=template&id=4882be27&scoped=true&"
import script from "./CalendarNavigation.vue?vue&type=script&lang=ts&"
export * from "./CalendarNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarNavigation.vue?vue&type=style&index=0&id=4882be27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882be27",
  null
  
)

export default component.exports